export const CloseIframeMessageType = 'CLOSE_IFRAME';
